import styled from 'styled-components';

import { Text, units } from '@calm-web/design-system';

export const SubsubsectionBody = styled.div`
	margin-left: ${units(2)};
`;

export const Container = styled.div`
	margin-left: ${units(2)};
`;

export const SubsubsectionTitle = styled(Text).attrs({
	el: 'h4',
})`
	margin-bottom: ${units(0.6)};
`;
